export const UXP_CLOSE_EMBEDDED_MEDIA_VIEWER = 'close-embedded-media-viewer';
export const UXP_SYNC_PREMIERE_PLAYHEAD = 'sync-premiere-playhead';
export const UXP_ADD_PREMIERE_MARKER = 'add-premiere-marker';

export type UxpPremiereSyncAssetId = { assetId: string };
